import { IItemInterface } from "./dataInterface"

//const ImageHost = "http://gruposina.net/static/";

const ImageHost = "https://static.enjoysushi.es/";

export interface IItemBebidaInterface extends IItemInterface {
    precio: number;
}

export const bebida: IItemBebidaInterface[] = 
[
    {
        'indicator': 1,
        'name': 'Coca-Cola',
        'description': '',
        //'image': 'https://images-gmi-pmc.edge-generalmills.com/3c2132ca-a86b-4c78-9e37-df6000f9d0c3.jpg',
        'image': ImageHost + 'assert/bebida/coca-cola.png',
        'alergenos': [],
        'picante': false, 
        'precio': 3.20
    },               
    {
        'indicator': 2,
        'name': 'Agua',
        'description': '',
        'image': ImageHost + 'assert/bebida/agua.png',
        'alergenos': [],
        'picante': false, 
        'precio': 2.75
    },
    {
        'indicator': 3,
        'name': 'Cerveza',
        'description': '',
        'image': ImageHost + 'assert/bebida/cerveza.png',
        'alergenos': [],
        'picante': false, 
        'precio': 3.20
    }, 
    {
        'indicator': 4,
        'name': 'Vino de la Casa',
        'description': '',
        'image': ImageHost + 'assert/bebida/vino.png',
        'alergenos': [],
        'picante': false, 
        'precio': 11.95
    }, 
    {
        'indicator': 5,
        'name': 'Casera',
        'description': '',
        'image': ImageHost + 'assert/bebida/casera.png',
        'alergenos': [],
        'picante': false, 
        'precio': 2.75        
    }, 
    {
        'indicator': 6,
        'name': 'Fanta de Naranja',
        'description': '',
        'image': ImageHost + 'assert/bebida/fanta.png',
        'alergenos': [],
        'picante': false, 
        'precio': 3.20
    },      
    {
        'indicator': 7,
        'name': 'Fanta de Limon',
        'description': '',
        'image': ImageHost + 'assert/bebida/fanta-limon.png',
        'alergenos': [],
        'picante': false,
        'precio': 3.20
    },
    {
        'indicator': 8,
        'name': 'Aquarium',
        'description': '',
        'image': ImageHost + 'assert/bebida/aquarium.png',
        'alergenos': [],
        'picante': false, 
        'precio': 3.50
    },
    {
        'indicator': 9,
        'name': 'Nestea',
        'description': '',
        'image': ImageHost + 'assert/bebida/nestea.png',
        'alergenos': [],
        'picante': false, 
        'precio': 3.50
    },
    {
        'indicator': 10,
        'name': 'Sangria',
        'description': '',
        'image': ImageHost + 'assert/bebida/sangria.png',
        'alergenos': [],
        'picante': false, 
        'precio': 11.95
    },
    {
        'indicator': 11,
        'name': 'Cerveza Sapporo',
        'description': '',
        'image': ImageHost + 'assert/bebida/sapporo.png',
        'alergenos': [],
        'picante': false, 
        'precio': 3.50
    },
    {
        'indicator': 12,
        'name': 'Cerveza Kirin',
        'description': '',
        'image': ImageHost + 'assert/bebida/kirin-coreana.webp',
        'alergenos': [],
        'picante': false, 
        'precio': 3.50
    },
    {
        'indicator': 13,
        'name': 'Jarra de Cerveza',
        'description': '',
        'image': ImageHost + 'assert/bebida/jarra.webp',
        'alergenos': [],
        'picante': false, 
        'precio': 3.95
    }             
]